import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IIndustry } from "../industryModel";

export const getAllIndustries = createAsyncThunk(
  "Industry/FindAllIndustry",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Industry/FindAllIndustry`,
        {
          Title: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Industries:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createIndustry = createAsyncThunk(
  "Industry/InsertIndustry",
  async (IndustryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Industry/InsertIndustry`,
        IndustryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Industry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateIndustry = createAsyncThunk(
  "Industry/UpdateIndustry",
  async (IndustryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Industry/UpdateIndustry`,
        IndustryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Industry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteIndustry = createAsyncThunk(
  "Industry/DeleteIndustry",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Industry/DeleteIndustry`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Industry :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getIndustryByID = createAsyncThunk(
  "Industry/FindByIDIndustry",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Industry/FindByIDIndustry`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        Title: result?.Title,
        URL: result?.URL,
        ShortDescription: result?.ShortDescription,
        LongDescription: result?.LongDescription,
        MainImage: result?.MainImage,
        BannerImage: result?.BannerImage,
        IndustryHeading: result?.IndustryHeading,
        AboutIndustry: result?.AboutIndustry,
        IndustrySuppliers: result?.IndustrySuppliers,
        AboutIndustryImage: result?.AboutIndustryImage,
        AboutIndustryAlterTag: result?.AboutIndustryAlterTag,
        IsActive: result?.IsActive ? 1 : 2,
      } as IIndustry;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Industry :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveIndustries = createAsyncThunk(
  "Industry/FindAllActiveIndustry",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Industry/FindAllActiveIndustry`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Industries:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveIndustry = createAsyncThunk(
  "Industry/ActiveInActiveIndustry",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Industry/ActiveInActiveIndustry`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Industry :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD
export const IndustryDetailsImageUpload = createAsyncThunk(
  "Industry/IndustryImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Industry/IndustryImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Industry Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
